import { render, staticRenderFns } from "./course-normal-list.vue?vue&type=template&id=2b331c66&scoped=true&"
import script from "./course-normal-list.vue?vue&type=script&lang=js&"
export * from "./course-normal-list.vue?vue&type=script&lang=js&"
import style0 from "./course-normal-list.vue?vue&type=style&index=0&id=2b331c66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b331c66",
  null
  
)

export default component.exports